import Vue from 'vue'
import Router from 'vue-router'
import LoginView from '@/components/views/Login'
import HomeView from '@/components/views/Home'
import DashboardView from '@/components/views/Dashboard'
import InvoiceView from '@/components/views/Accounting/Invoices'
import SapInvoiceView from '@/components/views/Accounting/SapInvoices'
import MonitoringErrors from '@/components/views/Monitoring/Errors'
import MonitoringLogs from '@/components/views/Monitoring/Logs'
import MonitoringJobs from '@/components/views/Monitoring/Jobs'
import MonitoringSap from '@/components/views/Monitoring/Sap'
import MonitoringLabels from '@/components/views/Monitoring/Labels'
import MonitoringNews from '@/components/views/Monitoring/News'
import MonitoringStatistics from '@/components/views/Monitoring/Statistics'
import OrdersView from '@/components/views/Orders'
import LabelsView from '@/components/views/NewLabels'
import UploaderView from '@/components/views/Uploader'
import SingleOrderView from '@/components/views/OrderSingle'
import CompaniesView from '@/components/views/Accounting/Companies'
import CompanyView from '@/components/views/Accounting/Company'
import ErpView from '@/components/views/Accounting/AdvancedConfig'
import StoresView from '@/components/views/Accounting/Stores'
import StoreCreateView from '@/components/views/Accounting/StoreCreate'
import SingleStoreView from '@/components/views/Accounting/StoreSingle'
import MerchantStatsView from '@/components/views/Statistics/MerchantStatistics'
import ProductStatsView from '@/components/views/Statistics/ProductStatistics'
import TopSellerView from '@/components/views/Statistics/TopSeller'
import BrandMonitoringView from '@/components/views/Monitoring/Brands'
import ClickCollectView from '@/components/views/ClickCollectOverview'
import SingleClickCollectView from '@/components/views/SingleClickCollect'
import ControllingStatsView from '@/components/views/ControllingStatsView'
import Fibu from '@/components/views/Fibu'
import Overview from '@/components/views/Overviews/Overview'
import SapOverview from '@/components/views/Overviews/SapOverview'
import ProductDetail from '@/components/views/SingleProduct'
import AvisUpload from '@/components/views/AvisUploader'
import FeesView from '@/components/views/Company/MarketplaceTax.vue'
import SapSalesChannelConf from '@/components/views/Sap/SapSalesChannelConf'
import OverviewUnknown from '@/components/views/Overviews/OverviewUnknown'
import OverviewComplaints from '@/components/views/Overviews/OverviewComplaints'
import EcommerceBrandsView from '@/components/views/Ecommerce/Brands'
import EcommerceProductsView from '@/components/views/Ecommerce/Products'
import EcommerceCategoriesView from '@/components/views/Ecommerce/Categories'
import SapCollectionInvoiceAnalyses from '@/components/views/SapCollectionInvoiceAnalyses'


Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: LoginView
    }, {
      path: '/home',
      component: HomeView,
      meta: {
        auth: true
      },
      children: [
        {
          path: '',
          component: DashboardView,
          name: 'dashboard',
          description: 'dashboard',
          meta: {
            auth: true
          }
        }, {
          path: '/download/invoices/:type',
          parent: 'accounting',
          component: InvoiceView,
          name: 'invoices_overview',
          description: 'Invoice management',
          meta: {
            auth: true
          }
        }, {
          path: '/download/sap/invoices/:type',
          parent: 'accounting',
          component: SapInvoiceView,
          name: 'sap_invoices_overview',
          description: 'Invoice management',
          meta: {
            auth: true
          }
        }, {
          path: '/avis',
          component: AvisUpload,
          name: 'avis_upload',
          meta: {
            auth: true
          }
        }, {
          path: '/orders',
          component: OrdersView,
          name: 'orders',
          description: 'Orders Table',
          meta: {
            auth: true
          }
        }, {
          path: '/labels',
          component: LabelsView,
          name: 'labels',
          description: 'Labels',
          meta: {
            auth: true
          }
        }, {
          path: '/reservations',
          component: ClickCollectView,
          name: 'reservations',
          meta: {
            auth: true
          }
        }, {
          path: '/fibu',
          component: Fibu,
          name: 'fibu',
          meta: {
            auth: true
          }
        }, {
          path: '/overview/sap',
          component: SapOverview,
          name: 'sap_overview',
          meta: {
            auth: true
          }
        }, {
          path: '/overview/unknown',
          component: OverviewUnknown,
          name: 'overview_unknown',
          meta: {
            auth: true
          }
        }, {
          path: '/overview/complaints',
          component: OverviewComplaints,
          name: 'overview_complaints',
          meta: {
            auth: true
          }
        }, {
          path: '/overview/:type',
          component: Overview,
          name: 'overview',
          meta: {
            auth: true
          }
        }, {
          path: '/reservations/:id',
          component: SingleClickCollectView,
          name: 'reservation',
          meta: {
            auth: true
          }
        }, {
          path: '/orders/:id',
          component: SingleOrderView,
          name: 'single_order',
          meta: {
            auth: true
          }
        }, {
          path: '/products/:company/:id',
          component: ProductDetail,
          name: 'single_product',
          meta: {
            auth: true
          }
        }, {
          path: '/controlling/stats',
          component: ControllingStatsView,
          name: 'controlling_stats',
          meta: {
            auth: true
          }
        }, {
          path: '/monitoring/errors',
          component: MonitoringErrors,
          name: 'monitoring',
          description: 'Monitoring Overview',
          meta: {
            auth: true
          }
        }, {
          path: '/monitoring/news',
          component: MonitoringNews,
          name: 'news',
          description: 'Create News',
          meta: {
            auth: true
          }
        }, {
          path: '/monitoring/statistics',
          component: MonitoringStatistics,
          name: 'monitoring_statistics',
          description: 'Monitor Statistics',
          meta: {
            auth: true
          }
        }, {
          path: '/monitoring/jobs',
          component: MonitoringJobs,
          name: 'jobs',
          description: 'Monitoring Jobs',
          meta: {
            auth: true
          }
        }, {
          path: '/sap/monitoring/jobs',
          component: MonitoringSap,
          name: 'SAP',
          description: 'Monitoring SAP',
          meta: {
            auth: true
          }
        }, {
          path: '/monitoring/labels',
          component: MonitoringLabels,
          name: 'label_errors',
          description: 'Monitoring Labels',
          meta: {
            auth: true
          }
        }, {
          path: '/monitoring/logs',
          component: MonitoringLogs,
          name: 'logs',
          description: 'Monitoring Errorlogs',
          meta: {
            auth: true
          }
        }, {
          path: '/accounting/companies',
          component: CompaniesView,
          parent: 'accounting',
          name: 'companies_overview',
          description: 'Company Account page',
          meta: {
            auth: true
          }
        }, {
          path: '/accounting/companies/:id/config/erp',
          component: ErpView,
          parent: 'accounting',
          name: 'erp_configuration',
          meta: {
            auth: true
          }
        }, {
          path: '/accounting/companies/:id/fees',
          component: FeesView,
          parent: 'accounting',
          name: 'fees',
          meta: {
            auth: true
          }
        }, {
          path: '/accounting/companies/:id',
          component: CompanyView,
          parent: 'accounting',
          name: 'company',
          description: 'Company Account page',
          meta: {
            auth: true
          }
        }, {
          path: '/accounting/stores',
          parent: 'accounting',
          component: StoresView,
          name: 'stores_overview',
          description: 'Store management',
          meta: {
            auth: true
          }
        }, {
          path: '/accounting/stores/new',
          parent: 'stores',
          grandparent: 'accounting',
          component: StoreCreateView,
          name: 'create_store',
          description: 'Store management',
          meta: {
            auth: true
          }
        }, {
          path: '/accounting/companies/:company_id/stores/:id',
          parent: 'company',
          grandparent: 'accounting',
          component: SingleStoreView,
          name: 'single_store',
          description: 'Store management',
          meta: {
            auth: true
          }
        }, {
          path: '/statistics/merchant',
          component: MerchantStatsView,
          name: 'statistics',
          meta: {
            auth: true
          },
          description: 'Statistics viewer'
        }, {
          path: '/statistics/topseller',
          component: TopSellerView,
          name: 'top_seller',
          meta: {
            auth: true
          },
          description: 'Statistics viewer'
        }, {
          path: '/monitoring/brands',
          component: BrandMonitoringView,
          name: 'brands_monitoring',
          meta: {
            auth: true
          },
          description: 'Monitoring brands'
        }, {
          path: '/statistics/product',
          component: ProductStatsView,
          name: 'product_statistics',
          meta: {
            auth: true
          },
          description: 'Statistics viewer'
        }, {
          path: '/upload',
          component: UploaderView,
          name: 'upload',
          meta: {
            auth: true
          }
        }, {
          path: '/ecommerce/brands',
          component: EcommerceBrandsView,
          name: 'eCommerce',
          meta: {
            auth: true
          }
        }, {
          path: '/ecommerce/articles',
          component: EcommerceProductsView,
          name: 'eCommerce',
          meta: {
            auth: true
          }
        }, {
          path: '/ecommerce/categories',
          component: EcommerceCategoriesView,
          name: 'eCommerce',
          meta: {
            auth: true
          }
        }, {
          path: '/sapconf/saleschannels',
          component: SapSalesChannelConf,
          name: 'sap_sales_channel_conf',
          meta: {
            auth: true
          }
        },{
          path: '/sapCollectionInvoiceAnalyses',
          component: SapCollectionInvoiceAnalyses,
          name: 'sap_collection_invoice_analyses',
          meta: {
            auth: true
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js